const STORAGE_KEY = 'maznut:ongoing-order-context';

export interface OngoingOrderContext {
  appName: string;
  restaurantName?: string;
  orderId?: number;
}

export function saveOngoingOrderContext(ctx: OngoingOrderContext): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ctx));
  } catch {
    // ignore storage errors
  }
}

export function readOngoingOrderContext(): OngoingOrderContext | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as OngoingOrderContext;
  } catch {
    return null;
  }
}

export function clearOngoingOrderContext(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export const ORDER_PLACED_EVENT = 'maznut:order-placed';

export function notifyOrderPlaced(appName: string, orderId: number, restaurantName?: string): void {
  saveOngoingOrderContext({ appName, orderId, restaurantName });
  window.dispatchEvent(
    new CustomEvent(ORDER_PLACED_EVENT, { detail: { appName, orderId, restaurantName } })
  );
}

export const ORDER_COMPLETED_EVENT = 'maznut:order-completed';

/** Fired when the guest's ongoing order reaches a completed status (any page). */
export function notifyOrderCompleted(appName: string, orderId: number): void {
  window.dispatchEvent(
    new CustomEvent(ORDER_COMPLETED_EVENT, { detail: { appName, orderId } })
  );
}
